export default {
  title: 'light',

  colors: {
    primary: '#04ccd3',
    secondary: '#a8a8b3',

    background: '#F2F2FA',
    backgroundItem: '#ffffff',
    backgroundInput: '#ffffff',

    title: '#3a3a3a',
    titleCard: '#3d3d4d',
    description: '#a8a8b3',
  },
};
